"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var switch_1 = require("./switch");
Object.defineProperty(exports, "Switch", { enumerable: true, get: function () { return __importDefault(switch_1).default; } });
//# sourceMappingURL=index.js.map